module.exports = __webpack_public_path__ + "img/hiuzong.dbb97790.png";